import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RelatorioDividasLayer from "../components/RelatorioDividasLayer";
import { useTranslation } from "../i18n/I18nContext";

const RelatorioDividasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("relatorioDividas.breadcrumb")} />
      <RelatorioDividasLayer />
    </MasterLayout>
  );
};

export default RelatorioDividasPage;
